import _ from 'lodash';

export const covenantKeyQueryParam = 'covenantKey';

export enum SideBarMode {
  root = 'root',
  settings = 'settings',
  settingsFacility = 'settingsFacility',
}

export const settingsPaths = {
  settings: '/settings',
  account: '/settings/my-account',
  facilities: '/settings/facilities',
  facilitiesBorrowingBase: '/settings/facilities/borrowing-base',
  facilitiesBorrowingBaseConfiguration:
    '/settings/facilities/borrowing-base/configuration',
  facilitiesBorrowingBaseLoanTape:
    '/settings/facilities/borrowing-base/loantape',
  facilitiesBorrowingBaseSandbox: '/settings/facilities/borrowing-base/sandbox',
  facilitiesMetadata: '/settings/facilities/metadata',
  facilitiesPortfolioCovenants: '/settings/facilities/portfolio-covenants',
  facilitiesPortfolioCovenantsConfiguration:
    '/settings/facilities/portfolio-covenants/configuration',
  facilitiesPortfolioCovenantsEdit:
    '/settings/facilities/portfolio-covenants/edit',
};

export const sideBarModeToPath: { mode: SideBarMode; path: string }[] = [
  {
    mode: SideBarMode.root,
    path: '/',
  },
  { mode: SideBarMode.settings, path: settingsPaths.settings },
  { mode: SideBarMode.settings, path: settingsPaths.facilities },
  {
    mode: SideBarMode.settingsFacility,
    path: settingsPaths.facilitiesBorrowingBase,
  },
  {
    mode: SideBarMode.settingsFacility,
    path: settingsPaths.facilitiesMetadata,
  },
];

export const getSideBarModeFromPath = ({
  currentPath,
}: {
  currentPath: string;
}): SideBarMode => {
  // order sideBarModeToPath in decending order by path so that the deepest route path matching is returned by _.find
  const orderedSideBarModeToPath = _.orderBy(sideBarModeToPath, 'path', 'desc');

  return (
    _.find(orderedSideBarModeToPath, ({ path }) =>
      _.startsWith(currentPath, path),
    )?.mode ?? SideBarMode.root
  );
};
